import React from 'react';
import {UnControlled as CodeMirrorComponent} from 'react-codemirror2';
import CodeMirror from 'codemirror';
import "codemirror/addon/mode/simple.js"; 
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import codeManager from './codemanager';
import "./codeeditor.css";
import ThemeContext from './themecontext';

export default class CodeEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = { theme: "dark" };

        CodeMirror.defineSimpleMode("pseudoasm", {
            // The start state contains the rules that are intially used
            start: [
              // The regex matches the token, the token property contains the type
              {regex: /(R|D)\d+/, token: "variable"},
              {regex: /(MEM|IO|JUMP|PUSH|POP|INT)\b/, token: "keyword"},
              {regex: /(IF)\b/, token: "builtin"},
              {regex: /true|false|null|undefined/, token: "atom"},
              {regex: /0x[a-f\d]+|(\s[-+])?(?:\.\d+|\d+\.?\d*)(?:e[-+]?\d+)?/i, token: "string"}, // token: "number"
              {regex: /[-+&|/*>!]/, token: "operator"},
              {regex: /==/, token: "operator"},
              {regex: /<[^-]/, token: "operator"},
              {regex: /(<-|←)/, token: "def"},      
            ],
        });
    }

    componentDidMount() {
        const pres = codeManager.parseCode(this.props.code);
        if (this.props.onChange)
            this.props.onChange(pres);
    }

    static contextType = ThemeContext;

    render() {
        return (
            <div className="code-editor-panel">
                <CodeMirrorComponent
                    value={this.props.code.replace(/<-/g, "←")}
                    options={{
                        mode: "pseudoasm",
                        theme: this.context === "dark" ? "material" : "default",
                        lineNumbers: true}}
                    onChange={(editor, data, value) => {
                        let lix = 0;
                        editor.eachLine(line => {
                            for (let cix=0; cix < line.text.length-1; cix++)
                                if (line.text[cix]==='<' && line.text[cix+1]==='-') {
                                    editor.getDoc().replaceRange("←", {line: lix, ch: cix}, {line: lix, ch: cix+2});
                                    break;
                                }
                            lix += 1;
                        });
                        const pres = codeManager.parseCode(editor.getValue());
                        if (this.props.onChange)
                            this.props.onChange(pres);
                    }}
                />
            </div>
        );
    }
}